import { createFileRoute } from "@tanstack/react-router";
import { applicationIntakesCreateApiRoute } from "@/features/applications";

export const Route = createFileRoute(
    "/api/internal/application-intakes/create",
)({
    ...applicationIntakesCreateApiRoute,
});
